import { Injectable } from '@angular/core';
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class EventService
{
    public getlist_subject: any = new Subject();
    public getlist_res_subject: any = new Subject();
    public page_reload_subject: any = new Subject();
    public show_hidden_subject: any = new Subject();
    public show_progress_subject: any = new Subject();
    public show_progress_empty_subject: any = new Subject();
    public show_progress_badge_subject: any = new Subject();
    public modal_subject: any = new Subject();
    public menu_subject: any = new Subject();
    public menu_button_subject: any = new Subject();
    public open_menu_subject: any = new Subject();

    constructor(
    )
    {
    }

    get getlistSubject(): Observable<any>
    {
        return this.getlist_subject.asObservable();
    }

    get getlistResSubject(): Observable<any>
    {
        return this.getlist_res_subject.asObservable();
    }

    get pageReloadSubject(): Observable<any>
    {
        return this.page_reload_subject.asObservable();
    }

    get showhiddenSubject(): Observable<any>
    {
        return this.show_hidden_subject.asObservable();
    }

    get showProgressSubject(): Observable<any>
    {
        return this.show_progress_subject.asObservable();
    }

    get showProgressEmptySubject(): Observable<any>
    {
        return this.show_progress_empty_subject.asObservable();
    }

    get showProgressBadgeSubject(): Observable<any>
    {
        return this.show_progress_badge_subject.asObservable();
    }

    get modalSubject(): Observable<any>
    {
        return this.modal_subject.asObservable();
    }

    get menuSubject(): Observable<any>
    {
        return this.menu_subject.asObservable();
    }

    get menuButtonSubject(): Observable<any>
    {
        return this.menu_button_subject.asObservable();
    }

    get openMenuSubject(): Observable<any>
    {
        return this.open_menu_subject.asObservable();
    }

    getCapUnit(org_size)
    {
        let unit = "B";
        let size = "0";

        if (org_size > 1048576000) {
            unit = "GB";
            size = (org_size / 1048576000).toFixed(1);
        } else if (org_size > 1048576) {
            unit = "MB";
            size = (org_size / 1048576).toFixed(1);
        } else if (org_size > 1024) {
            unit = "KB";
            size = (org_size / 1024).toFixed(1);
        } else {
            size = org_size;
        }

        return size+unit;
    }

    getTimestampToDate(tm)
    {
        const datetime = new Date(tm * 1000);

        const yyyy = datetime.getFullYear();
        let mm = String(datetime.getMonth() + 1);
        mm = ('00' + mm).slice(-2);
        let dd = String(datetime.getDate());
        dd = ('00' + dd).slice(-2);
        const h = ('00' + datetime.getHours()).slice(-2);
        const m = ('00' + datetime.getMinutes()).slice(-2);
        const s = ('00' + datetime.getSeconds()).slice(-2);

        return `${yyyy}/${mm}/${dd} ${h}:${m}:${s}`;
    }
}
